import { render, staticRenderFns } from "./ErrorCard.vue?vue&type=template&id=3ec6e9f5&scoped=true"
import script from "./ErrorCard.vue?vue&type=script&lang=js"
export * from "./ErrorCard.vue?vue&type=script&lang=js"
import style0 from "./ErrorCard.vue?vue&type=style&index=0&id=3ec6e9f5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ec6e9f5",
  null
  
)

export default component.exports